import Vue from 'vue';
import App from '@/App';
import VueMeta from 'vue-meta';
import router from '@/router/router';
import store from '@/store/store';
import i18n from './locales/i18n';
import '@/validate/validate';
import { BootstrapVue, TooltipPlugin } from 'bootstrap-vue';
import { FontAwesomeIcon, FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { icons } from '@/assets/styles/fontawesome.js';
import VueLazyload from 'vue-lazyload';
import { DpAxiosInit, DpSentryInit, installTestIdDirective } from '@docupet/component-library';

// Initialize DocuPet's Axios and pass $store
DpAxiosInit(store);

const env = (process.env?.VUE_APP_ENV || process.env?.NODE_ENV)?.toLowerCase();
if (env !== 'local') {
  DpSentryInit(Vue, 'https://4022cceb1ab84af4bf3d751e1944cf8b@o452146.ingest.sentry.io/5816157', env);
}

Vue.use(VueMeta);
Vue.use(TooltipPlugin);
Vue.use(BootstrapVue);
installTestIdDirective(Vue);
Vue.use(VueLazyload, {
  preLoad: 1.3,
  observer: true,
  attempt: 3,
});

library.add(icons);
Vue.component('fa-icon', FontAwesomeIcon);
Vue.component('font-awesome-layers', FontAwesomeLayers);
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');

window.bootstrap = require('bootstrap');